import link from './link';
import anchor from './anchor';
export default {
  anchor,
  link,
};
